import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  isLoading = new BehaviorSubject(false);
  activeLoading: boolean;
  enableReSend: BehaviorSubject<boolean> = new BehaviorSubject(false);
  publicActiveFormGroup: UntypedFormGroup;
  reCaptchaToken: string;
  siteKey: string;
  authToken: any;
  hintCodeSmsValidate: string;
  globalEnvironments: { s3Bucket: string; oldVersion: string; apiEndpoint: any; apiSecret: string; AmplifyAuth: any; captchaKey: string; apiKey:string };
  timeoutActive: Subject<boolean> = new Subject();
  //
  constructor() {
    this.siteKey = '6Lc8UdIZAAAAAIGlf8PNGfGxqJySWE1_7YUd_oW8';
  }

  showLoading() {
    this.activeLoading = true;
    setTimeout(() => this.isLoading.next(true), 50);
  }

  hideLoading() {
    this.activeLoading = false;
    setTimeout(() => this.isLoading.next(false), 50); 
  }

  takeAWhile() {
    return timer(1, 1000).pipe(
      takeWhile(($) => {
        if ($ === 60) {
          this.enableReSend.next(true);
        }
        return $ <= 60;
      }),
      map(($) => 60 - $)
    );
  }
}
